import { createFileRoute } from '@tanstack/react-router'
import { KnowledgeBasePage } from '@/features/ndis-standards/knowledge-base'

export const Route = createFileRoute('/_authenticated/_organization/ndis-standards/knowledge-base')({
  component: KnowledgeBasePage,
})
